module.exports = __webpack_public_path__ + "img/course_009.4f5d327.webp";